import { createAction } from '@reduxjs/toolkit';

export const REMOVE_USER = 'REMOVE_USER';

export const removeUser = createAction(
    REMOVE_USER,
    () => ({ payload: [] }),
);
